import React from 'react';
import axios from 'axios';
import _ from 'lodash';
import { ModalContent, ModalFooter, ModalButton, useDialog, Confirm, Alert } from 'react-st-modal';
import CryptoJS from 'crypto-js';
import ralcolor from '../components/ral_color.json';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import moment from 'moment';

const Loader = () => <div className="page-loader-wrapper">
    <div className="loader">
        <div className="mt-3"><img className="zmdi-hc-spin w60" src="assets/images/loader.svg" alt="Thyme" /></div>
        <p>Please wait...</p>
    </div>
</div>;

const DoLogin = async (loginItems) => {

    await axios(PostOptions('POST', loginItems, 'authenticate')).then(res => {
        let user = DecryptData(res.data);

        if (user.profile.status == 0) {
            showAlert({ title: 'Login Error', message: `Your credentials are currently disabled, please contact Admin...`, btnText: 'OK' });

            return;
        } else if (!user.hasAccess) {
            showAlert({ title: 'Login Error', message: `You cannot login at this time, please contact Admin...`, btnText: 'OK' });

            return;
        }

        // console.log('Assigned Branches: ',JSON.stringify(user?.assignedBranches.map(ab => ab.branch)) );
        SetToken(user.jwttoken);
        SetUser(user.profile);
        SetCookie(`thyme_web${prefix()}_role`, JSON.stringify(user.role));
        SetCookie(`thyme_web${prefix()}_sub_features`, user.role.subFeatures);
        SetCookie(`thyme_web${prefix()}_branch`, JSON.stringify(user.branch));
        SetCookie(`thyme_web${prefix()}_company`, JSON.stringify(user.company));
        SetCookie(`thyme_web${prefix()}_prepo_raw`, JSON.stringify(user.prepopulates));
        SetCookie(`thyme_web${prefix()}_assigned_branch`, JSON.stringify((user?.assignedBranches || []).map(ab => ab.branch)));
        SetCookie(`thyme_web${prefix()}_prepo`, JSON.stringify(_.groupBy(user.prepopulates, 'pretype')));
        SetCookie(`thyme_web${prefix()}_terminology`, JSON.stringify(_.groupBy(user.terminologies, 'termType')));
        SetFeatures(user.role.features);

        window.location.reload();
    }).catch(error => { showAlert({ title: 'Login Error', message: `Login failed, check your credentials and try again...${error.message}`, btnText: 'OK' }); });
}

const Logout = () => {
    sessionStorage.removeItem(`thyme_web${prefix()}_token`);
    sessionStorage.removeItem(`thyme_web${prefix()}_role`);
    sessionStorage.removeItem(`thyme_web${prefix()}_user`);
    sessionStorage.removeItem(`thyme_web${prefix()}_features`);
    sessionStorage.removeItem(`thyme_web${prefix()}_prepo`);
    sessionStorage.removeItem(`thyme_web${prefix()}_sub_features`);
    sessionStorage.removeItem(`thyme_web${prefix()}_prepo_raw`);
    sessionStorage.removeItem(`thyme_web${prefix()}_assigned_branch`);

    sessionStorage.removeItem(`thyme_web${prefix()}_company`);
    sessionStorage.removeItem(`thyme_web${prefix()}_branch`);
    sessionStorage.removeItem(`thyme_web${prefix()}_terminology`);

    // window.location.reload();
    window.location.replace(
    //     `https://thymeconsultghana.com/${prefix()}/`
        `https://test.thymeconsultghana.com/`
    );
}

const prefix = () => {
    return (
        ''
        // 'test'
        // 'thyme_test'
        // 'tscl'
        // 'metfab'
        // 'asangod'
        // 'adepaye'
        // 'kkpeprah'
        // 'umbrella'
        // 'siblings'
        // 'adabof'
        // 'advance'
        // 'alufab'
        // 'rooftech'
        // 'davida'
        // 'DMRoofing'
        // 'jelenock'
        // 'cityroof'
        // 'westfall'
        // 'sunshield'
        // 'agesrock'
        // 'highline'
        // 'cosgam'
        // 'luckystar'
        // 'metalex'
        // 'jaroof'
        // 'desky'
        // 'yaks'
        // 'kbest'
        // 'firstdoor'
        // 'jenellco'
        // 'dophil'
    );
}

const BaseURL = () => {//7911328615
    // return 'https://thymeconsultghana.com/test_api/'; //live-test
    // return 'https://thymeconsultghana.com/tscl_api/'; //live-tscl
    // return 'https://thymeconsultghana.com/metfab_api/'; //live-metfab
    // return 'https://thymeconsultghana.com/asangod_api/'; //live-asangod
    // return 'https://thymeconsultghana.com/adepaye_api/'; //live-adepaye
    // return 'https://thymeconsultghana.com/kkpeprah_api/'; //live-kkpeprah
    // return 'https://thymeconsultghana.com/umbrella_api/'; //live-umbrella
    // return 'https://thymeconsultghana.com/siblings_api/'; //live-siblings
    // return 'https://thymeconsultghana.com/adabof_api/'; //live-Adabof
    // return 'https://thymeconsultghana.com/advance_api/'; //live-Advance
    // return 'https://thymeconsultghana.com/alufab_api/'; //live-Alu-Fab
    // return 'https://thymeconsultghana.com/rooftech_api/'; //live-rooftech
    // return 'https://thymeconsultghana.com/davida_api/'; //live-danida
    // return 'https://thymeconsultghana.com/damerko_api/'; //live-damerko
    // return 'https://thymeconsultghana.com/jelenock_api/'; //live-jelenock
    // return 'https://thymeconsultghana.com/cityroof_api/'; //live-cityroof
    // return 'https://thymeconsultghana.com/westfall_api/'; //live-westfall
    // return 'https://thymeconsultghana.com/sunshield_api/'; //live-sunshield
    // return 'https://thymeconsultghana.com/agesrock_api/'; //live-agesrock
    // return 'https://thymeconsultghana.com/highline_api/'; //live-highline
    // return 'https://thymeconsultghana.com/cosgam_api/'; //live-cosgam
    // return 'https://thymeconsultghana.com/luckystar_api/'; //live-luckystar
    // return 'https://thymeconsultghana.com/metalex_api/'; //live-metalex
    // return 'https://thymeconsultghana.com/jaroof_api/'; //live-jaroof
    // return 'https://thymeconsultghana.com/desky_api/'; //live-desky
    // return 'https://thymeconsultghana.com/yaks_api/'; //live-yaks
    // return 'https://thymeconsultghana.com/kbest_api/'; //live-kbest
    // return 'https://thymeconsultghana.com/firstdoor_api/'; //live-firstdoor
    // return 'https://thymeconsultghana.com/jenellco_api/'; //live-jenellco
    // return 'https://thymeconsultghana.com/dophil_api/'; //live-dophil
    return 'https://test-bknd.thymeconsultghana.com/'; //thyme-test
    // return 'http://192.168.0.101:8292/'; //office
    // return 'http://localhost:8292/';
}

const EncryptData = (data) => {
    let keyHex = CryptoJS.enc.Base64.parse(PrivateKey());
    let encrypted = CryptoJS.AES.encrypt(data, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
}

const DecryptData = (data) => {
    let keyHex = CryptoJS.enc.Base64.parse(PrivateKey());
    let decrypted = CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(data)
    }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    let result = decrypted.toString(CryptoJS.enc.Utf8);

    try {
        return JSON.parse(result);
    } catch (error) {
        return result;
    }
}

const PrivateKey = () => '5YUlI77TTZYW18b6SP6A7KTg3Jq6Gh4No4Ea8Y3g7CA=';

const SetUser = (user) => sessionStorage.setItem(`thyme_web${prefix()}_user`, JSON.stringify(user));
const GetUser = () => JSON.parse(sessionStorage.getItem(`thyme_web${prefix()}_user`));

const SetToken = (token) => sessionStorage.setItem(`thyme_web${prefix()}_token`, token);
const GetToken = () => sessionStorage.getItem(`thyme_web${prefix()}_token`);

const GetAuthorization = () => (IsAuthenticated) ?
    { 'username': GetUser().username, 'token': GetToken() } :
    { 'username': '', 'token': '' };

const SetFeatures = (userole) => sessionStorage.setItem('features', JSON.stringify(userole));
const GetFeatures = () => JSON.parse(sessionStorage.getItem('features'));

const LengthFormat = (amount) => {
    const company = GetJCookie(`thyme_web${prefix()}_company`);
    const cf = new Intl.NumberFormat(`en-GB`,
        { maximumFractionDigits: 4, minimumFractionDigits: 4 });

    return cf.format(amount);
}

const CurFormat = (amount) => {
    const company = GetJCookie(`thyme_web${prefix()}_company`);
    const cf = new Intl.NumberFormat(`en-GB`,
        { maximumFractionDigits: 2, minimumFractionDigits: 2 });

    return cf.format(amount);
}

const NumFormat = (amount) => {
    //const company = GetJCookie(`thyme_web${prefix()}_company`);
    const cf = new Intl.NumberFormat(`en-GB`,
        { maximumFractionDigits: 0, minimumFractionDigits: 0 });

    return cf.format(amount);
}

const DateFormat = (curDate, style) => { // style: full, long, medium, short
    const company = GetJCookie(`thyme_web${prefix()}_company`);
    const cf = new Intl.DateTimeFormat(`${company.dateformat}`,
        { dateStyle: style });

    return cf.format(curDate);
}

const nl2br = (text) =>
    text
        .split(/(?:\r\n|\r|\n)/)
        .reduce(
            (res, frag, i, arr) => [
                ...res,
                frag,
                ...(i < arr.length - 1 && [React.createElement("br")])
            ],
            []
        );

const Local = { format: "DD-MM-YYYY", sundayFirst: false };

const DateRange = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
};

const MonthRange = {
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
}

const SetCookie = (name, value) => sessionStorage.setItem(name, value);
const GetCookie = (name) => sessionStorage.getItem(name);
const GetJCookie = (name) => {
    try {
        return JSON.parse(sessionStorage.getItem(name));
    } catch (error) {
        console.log(error);
    }
}

const IsAuthenticated = () => GetUser() !== null;

const HandleError = (error, func) => {
    if (func !== undefined) {
        func(false);
    }

    if (error.response !== undefined && error.response.status === 401) {
        showAlert({ title: "Error", message: `Your session has expired`, btnText: 'Ok' });
        Logout();
    } else {
        let msg = (error.response !== undefined && error.response.message !== undefined) ? error.response.message : error.message;
        console.log({ title: "Error", message: msg, btnText: 'Ok' });
        console.log(error);
    }
}

const showAlert = async ({ message, title, btnText }) => await Alert(message, title, btnText);
const showConfirm = async ({ message, title, btnText }) => await Confirm(message, title, btnText[0], btnText[1]);

const MakeId = (length) => {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;

    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const DConnect = () => {
    return axios.create({
        baseURL: BaseURL() + 'v1.0/',
        timeout: 60000000,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${GetToken()}`
        }
    });
}

const PostOptions = (meth, formBody, area) => {
    let formData = `data=${encodeURIComponent(EncryptData(JSON.stringify(formBody)))}`;

    // console.log('BaseURL: ', BaseURL() + 'v1.0/' + area);

    return {
        method: meth,
        url: BaseURL() + 'v1.0/' + area,
        data: formData,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': `Bearer ${GetToken()}`
        }
    }
}

const PostImageOptions = (meth, formBody, area) => {
    const formData = new FormData();

    formData.append(
        "logo",
        formBody
    );

    return {
        method: meth,
        url: BaseURL() + 'v1.0/' + area,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data; charset=UTF-8',
            'Authorization': `Bearer ${GetToken()}`
        }
    }
}

const GetCurl = (location, itm) => {
    let loc = location.hash.split('/');
    return loc[itm];
};

const custIdFormat = (id) => {
    let result = `${id}`;

    while (result.length < 5) {
        result = `0${result}`;
    }

    return result;
}

const Table = (props) => {
    const tableData = (props.data === undefined) ? [] : props.data;
    const { ExportCSVButton } = CSVExport;
    const { SearchBar } = Search;
    const MySearch = (props) => {
        let input;
        const handleClick = () => { props.onSearch(input.value); };
        return (
            <input
                className="form-control form-control-sm float-right"
                style={{ maxWidth: '250px' }} placeholder='Search'
                ref={n => input = n} type="search" onChange={handleClick} />
        );
    };

    const paginationOption = {
        totalSize: tableData.length,
        sizePerPageList: [{ text: '20', value: 20 }, { text: '50', value: 50 }, { text: '100', value: 100 },
        { text: '200', value: 200 }, { text: '500', value: 500 }, { text: 'All', value: tableData.length }]
    };

    const selectRow = props.select;

    return (<div>
        <ToolkitProvider bootstrap4 keyField={props.keys} data={tableData} columns={props.columns} exportCSV search >
            {props => (
                <div>
                    <div className="row">
                        <div className="col"><ExportCSVButton {...props.csvProps}><button className="btn btn-sm btn-outline-default"><FontAwesomeIcon icon={faFileCsv} /> Export CSV</button></ExportCSVButton></div>
                        <div className="col text-right"><MySearch {...props.searchProps} /></div>
                    </div>

                    <hr style={{ margin: '0' }} />
                    <BootstrapTable wrapperClasses="table-responsive" striped hover condensed responsive printable selectRow={selectRow} {...props.baseProps} pagination={paginationFactory(paginationOption)} />
                </div>
            )}
        </ToolkitProvider>
    </div>);
};

const pageOption = (tableData) => ({
    totalSize: tableData.length,
    sizePerPageList: [{ text: '20', value: 20 }, { text: '40', value: 40 }, { text: 'All', value: tableData.length }]
});

const pageOptions = (dataCount) => ({
    totalSize: dataCount,
    sizePerPageList: [{ text: '20', value: 20 }, { text: '40', value: 40 }, { text: 'All', value: dataCount }]
});

const RalConvert = (ralcode) => ralcolor[`${ralcode.replace(/[^0-9]/g, '')}`];

const unitConvert = (unitFrom, unitTo, value) => {
    if (unitFrom === 'metre' && unitTo === 'feet') {
        let num_in = value / 0.0254,
            num_ft = parseInt(num_in / 12),
            num_dec = num_in - (12 * num_ft);

        return parseFloat(`${num_ft}.${num_dec.toFixed(2)}`);
    } else if (unitFrom === 'feet' && unitTo === 'metre') {
        let num = `${value}`.split('.', 2),
            numdec = (num[1] === undefined) ? 0 : parseInt(num[1]) * 0.0254,
            numint = parseInt(num[0]) * 0.3048;

        return (numint + numdec).toFixed(2);
    } else if (unitFrom === 'inch' && unitTo === 'metre') {
        return (value * 0.0254).toFixed(2);
    } else if (unitFrom === 'metre' && unitTo === 'inch') {
        return (value * 39.3701).toFixed(2);
    } else if (unitFrom === 'igirth' && unitTo === 'mgirth') {
        let w_dec = value * 100 / 12,
            m_girth = parseFloat(((parseInt(value) + w_dec) / 3.281).toFixed(2));

        return m_girth;
    } else if (unitFrom === 'mgirth' && unitTo === 'igirth') {
        let w_dec = value * 3.281,
            i_girth = parseFloat((w_dec * 12 / 100).toFixed(2));

        return i_girth;
    }

    return 0;
}

const calcAccessory = (atype, length, stockqty) => {
    if (atype === 'screws') {
        return Math.ceil(length * stockqty * 3.5);
    } else if (atype === 'clips') {
        return Math.ceil(length * stockqty * 1.2);
    }

    return 0;
}

const NumtoWords_new = (n) => {

    const streverse = n => `${n}`.split("").reverse().join("");
    const strsplit = n => streverse(n).match(/.{2,3}(?=..)|.+/g);
    const num = x => Number(x) || 0;
    const isEmpty = xs => xs.length === 0;
    const reverse = xs => xs.slice(0).reverse();
    const comp = f => g => x => f(g(x));
    const not = x => !x;
    const thousand = (group, i) => group === '' ? group : `${group} ${g[i]}`;
    const makeGroup = ([ones, tens, huns]) => {
        // alert(JSON.stringify([ones, tens, huns]))
        return [
            num(huns) === 0 ? '' : a[huns] + ' hundred ',
            num(ones) === 0 ? 'and ' + b[tens] : b[tens] && 'and ' + b[tens] + '-' || 'and ',
            a[tens + ones] || a[ones]
        ].join('');
    }

    let a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'],
        b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'],
        g = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion'];

    if (n === '0') return 'zero';

    return strsplit(n)
        .map(makeGroup)
        .map(thousand)
        .filter(comp(not)(isEmpty))
        .reverse()
        .join(' ').replace(/^and\s|\sand\s*$/, '');
}

const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function twoDigitToWords(n) {
    n = Number(n);
    if (n === 0) return '';
    if (n < 20) return a[n];
    return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
}

function threeDigitToWords(n) {
    n = Number(n);
    let str = '';
    let hundreds = Math.floor(n / 100);
    let rest = n % 100;
    if (hundreds > 0) str += a[hundreds] + ' Hundred';
    if (rest > 0) {
        if (str !== '') str += ' and ';
        str += twoDigitToWords(rest);
    }
    return str;
}
function NumtoWords(number) {
    if (typeof number === 'string') number = Number(number);
    if (isNaN(number) || number > 999999999) return 'overflow';
    if (number === 0) return 'Zero GH Cedis';

    const [intPart, decPartRaw] = number.toFixed(2).split('.'); // ensures 2 decimal digits
    let num = parseInt(intPart, 10);
    let str = '';
    let millions = Math.floor(num / 1000000);
    num = num % 1000000;
    let thousands = Math.floor(num / 1000);
    num = num % 1000;

    if (millions > 0) {
        str += threeDigitToWords(millions) + ' Million';
    }
    if (thousands > 0) {
        if (str !== '') str += ' ';
        str += threeDigitToWords(thousands) + ' Thousand';
    }
    if (num > 0) {
        if (str !== '') str += ' ';
        str += threeDigitToWords(num);
    }

    str = str.trim();

    if (str !== '') {
        str += ' GH Cedis';
    }

    // Handle decimal part, e.g. "Fifty Pesewas"
    let decPart = parseInt(decPartRaw, 10);
    if (decPart > 0) {
        str += ', ' + twoDigitToWords(decPart) + ' Pesewas';
    }

    return str;

}

const Menu = [
    {
        code: '1', name: 'Dashboard', icon: 'view-dashboard', link: "dashboard",
        submenu: [
            { code: 1, role: 'Information', link: "informational", name: "Informational" },
            { code: 2, role: 'Analytic', link: "analytical", name: "Cash Flow & Expense" },
            { code: 3, role: 'Strategic', link: "strategical", name: "POS" }
        ]
    },
    {
        code: '2', name: 'Data Update', icon: 'keyboard', link: "data",
        submenu: [
            { code: 2, role: 'Proforma Invoices', link: "proforma_invoice", name: "Proforma Invoices" },
            { code: 7, role: 'Confirm Proforma', link: "confirm_proforma", name: "Confirm Proforma" },
            { code: 10, role: 'Complete Production', link: "complete_production", name: "Complete Production" },
            { code: 9, role: 'Warehouse Receiving', link: "warehouse_receiving", name: "Warehouse Receiving" },
            { code: 4, role: 'Invoice / Waybills', link: "waybill", name: "Invoice / Waybill" },
            { code: 5, role: 'Damaged Items / Protocols', link: "damage_protocol", name: "Damaged Items / Protocols" },
            { code: 6, role: 'Returned Products / Cheques', link: "return_checks", name: "Returned Products / Cheque" }
        ]
    },

    {
        code: '7', name: 'Cashier', icon: 'money-box', link: "cashier",
        submenu: [
            { code: 1, role: 'Sales Receipt', link: "sale_receipt", name: "Sales Receipt" },
            { code: 5, role: 'Cash Payment', link: "cash_payment", name: "Cash Payment" },
            { code: 2, role: 'Expenses', link: "expense", name: "Expenses" },
            { code: 4, role: 'Transfer Cash', link: "cash_transfer", name: "Transfer Cash" },
            { code: 3, role: 'Sales Receipt Report', link: "sales_report", name: "Sales Receipt Report" }
        ]
    },

    {
        code: '6', name: 'POS', icon: 'store', link: "pos",
        submenu: [
            { code: 1, role: 'Sales', link: "sales", name: "Sales" },
            { code: 2, role: 'Stocks', link: "stocks", name: "Stocks" },
            { code: 3, role: 'Invoice', link: "invoice", name: "Invoice" },
            { code: 9, role: 'Credit Invoice', link: "credit_invoice", name: "Credit Invoice" },
            { code: 6, role: 'Cash Transfer', link: "cash_transfer", name: "Transfer Cash" },
            { code: 8, role: 'Cash Payment', link: "cash_payment", name: "Cash Payment" },
            { code: 10, role: 'Credit POS Payment', link: "credit_pos_payment", name: "Credit POS Payment" },
            { code: 7, role: 'Expenses', link: "pos_expense", name: "Expenses" },
            { code: 5, role: 'Sales Reversal', link: "reversal", name: "Sales Reversal" },
            {
                code: 4, role: 'Report', link: "report", name: "Report",
                extra: [
                    { code: 0, name: "POS Sales Receipt" },
                    { code: 1, name: "Stock Balance" },
                    { code: 2, name: "Product Summary" },
                    { code: 3, name: "Customer Summary" },
                    { code: 4, name: "Tally Card" },
                    { code: 5, name: "POS Sales" }
                ]
            }
        ]
    },

    {
        code: '8', name: 'Trusses', icon: 'balance', link: "truss",
        submenu: [
            { code: 1, role: 'Truss Invoice', link: "truss_invoice", name: "Truss Invoice" },
            { code: 2, role: 'Confirm Truss', link: "truss_confirm", name: "Confirm Truss" },
            { code: 3, role: 'Complete Production', link: "truss_production", name: "Complete Production" },
            { code: 4, role: 'Receive to Warehouse', link: "truss_warehouse", name: "Receive to Warehouse" },
            { code: 5, role: 'Truss Invoice/Waybill', link: "truss_waybill", name: "Truss Invoice/Waybill" }
        ]
    },

    {
        code: '9', name: 'Coils', icon: 'balance', link: "coil",
        submenu: [
            { code: 1, role: 'Receive Coils', link: "receive_coils", name: "Receive Coils" },
            { code: 2, role: 'Transfer Coils', link: "transfer_coils", name: "Transfer Coils" },
            { code: 3, role: 'Issue Coils', link: "issue_coils", name: "Issue Coils" },
            { code: 4, role: 'Coil Sales', link: "coil_sales", name: "Coil Sales" },
            { code: 5, role: 'Coils Report', link: "report_coil", name: "Coils Reports",
                extra: [
                    { code: 0, name: "Received Coils" },
                    { code: 1, name: "Transferred Coils" },
                    { code: 2, name: "Issued Coils" },
                    { code: 3, name: "Used Coils" },
                    // { code: 4, name: "Coil Summary" },
                    { code: 4, name: "Stock Balance" }
                ]
             }
        ]
    },

    {
        code: '10', name: 'POS Production', icon: 'industry', link: "pos-production",
        submenu: [
            { code: 1, role: 'Production Request', link: "request", name: "Production Request" },
            { code: 2, role: 'Production', link: "complete", name: "Production" },
            { code: 3, role: 'Warehouse', link: "warehouse", name: "Warehouse" },
            { code: 4, role: 'Warehouse Stock', link: "warehouse-stock", name: "Warehouse Stock" },
            { code: 5, role: 'Supply Request', link: "supply", name: "Supply Request" },
            { code: 6, role: 'Print Waybill', link: "waybill", name: "Print Waybill"}
        ]
    },

    {
        code: '5', name: 'Authorization', icon: 'calendar-check', link: "authorization",
        submenu: [
            {
                code: 1, role: 'Long Span PFI / Invoice', link: "invoice", name: "Long Span PFI / Invoice",
                extra: [
                    { code: 0, name: "Confirm PFI" },
                    { code: 1, name: "Re-calulate PFI" },
                    { code: 2, name: "Assign PFI" },
                    { code: 3, name: "Edit PFI" },
                    { code: 4, name: "Extra Discount" },
                    { code: 5, name: "Exempt VAT" }
                ]
            },
            {
                code: 7, role: 'Truss PFI / Invoice', link: "trussinvoice", name: "Trusses PFI / Invoice",
                extra: [
                    { code: 0, name: "Confirm PFI" },
                    { code: 1, name: "Re-calulate PFI" },
                    { code: 2, name: "Assign PFI" },
                    { code: 3, name: "Edit PFI" },
                    { code: 4, name: "Extra Discount" },
                    { code: 5, name: "Exempt VAT" }
                ]
            },
            {
                code: 2, role: 'Payment', link: "payment", name: "Payments",
                extra: [
                    { code: 0, name: "Fund Transfer" },
                    { code: 1, name: "Clearance" },
                    { code: 2, name: "Commission" },
                    { code: 3, name: "Installation" },
                    { code: 4, name: "Transportation" },
                    { code: 5, name: "Pay PFI with Bal." },
                    { code: 6, name: "Customer Adjustment" },
                    { code: 7, name: "Payment Reversal" },
                    { code: 8, name: "Transfer Reversal" }
                ]
            },
            {
                code: 3, role: 'Waybill', link: "waybill", name: "Waybill",
                extra: [
                    { code: 0, name: "Waybill Invoices" },
                    { code: 1, name: "Cancel Waybill" },
                    { code: 2, name: "Refund" },
                    { code: 3, name: "Damaged Items" },
                    { code: 4, name: "Returned Items" },
                    { code: 5, name: "POS Credit" }
                ]
            },
            {
                code: 8, role: 'Truss Waybill', link: "trusswaybill", name: "Truss Waybill",
                extra: [
                    { code: 0, name: "Waybill Invoices" },
                    { code: 1, name: "Cancel Waybill" },
                    { code: 2, name: "Refund" },
                    { code: 3, name: "Damaged Items" },
                    { code: 4, name: "Returned Items" }
                ]
            },
            {
                code: 4, role: 'Receipt', link: "receipt", name: "Receipt",
                extra: [
                    { code: 0, name: "Cancel Receipt" },
                    { code: 1, name: "Cancel POS Sales" }
                ]
            },
            {
                code: 5, role: 'Vouchers', link: "voucher", name: "Vouchers",
                extra: [
                    { code: 0, name: "Commission" },
                    { code: 1, name: "Installation" },
                    { code: 2, name: "Transportation" },
                    { code: 3, name: "Refund" },
                    { code: 4, name: "Expense" }
                ]
            },
            {
                code: 6, role: 'POS Production', link: "pos-production", name: "POS Production",
                extra: [
                    { code: 0, name: "Production Request" },
                    { code: 1, name: "Supply Request" }
                ]
            },
            // {code:7, role:'Assign PFI', link: "assign_pfi", name: "AssignPFI"},
            // {code:5, role:'Cancel Waybill', link: "cancel_waybill", name: "Cancel Waybill"},
            // {code:6, role:'Commission', link: "commission", name: "Commission / Installation"}
        ]
    },

    {
        code: '3', name: 'Reports', icon: 'book', link: "report",
        submenu: [
            // {code:1, role:'Sales Receipt', link: "sales", name: "Sales Receipt"},
            { code: 2, role: 'Customer Statements', link: "custran", name: "Customer Statements" },
            { code: 3, role: 'Installation / Transport', link: "install_trans", name: "Installation / Transport" },
            { code: 4, role: 'Customer Balances', link: "custbal", name: "Customer Balances" },
            { code: 5, role: 'Product List', link: "product_list", name: "Product List" },
            { code: 6, role: 'Product Prices', link: "product_price", name: "Product Prices" },
            { code: 7, role: 'Stock Taking Sheet', link: "stock_sheet", name: "Stock Taking Sheet" },
            { code: 8, role: 'Returned Cheques', link: "returned_cheque", name: "Returned Cheques" },
            { code: 9, role: 'Returned Damages', link: "damages", name: "Returned Damages" },
            { code: 10, role: 'Acks and Confirmed Orders', link: "acks_confirmed", name: "Acks and Confirmed Orders" },
            // {code:11, role:'Protocol Report', link: "protocol", name: "Protocol Report"},
            { code: 12, role: 'Transaction Adjustments', link: "trans_adjust", name: "Transaction Adjustments" },
            { code: 13, role: 'Proforma Invoice and Waybill', link: "invoice", name: "Proforma Invoice and Waybill" },
            { code: 14, role: 'Proforma Invoice Status', link: "invoice_status", name: "Proforma Invoice Status" },
            { code: 15, role: 'Sales Personnel Commission', link: "sales_commission", name: "Sales Personnel Commission" },
            { code: 16, role: 'Discount Commission', link: "discount_commission", name: "Discount Commission" },
            { code: 17, role: 'Cost of Sales (Long Span)', link: "cost_of_sales_longspan", name: "Cost of Sales (Long Span)" },
            { code: 18, role: 'Cost of Sales (POS)', link: "cost_of_sales_pos", name: "Cost of Sales (POS)" },
            { code: 19, role: 'Cost of Sales (Trusses)', link: "cost_of_sales_truss", name: "Cost of Sales (Trusses)" },
            { code: 20, role: 'Cash Statement', link: "cash_statement", name: "Cash Statement" },
            // { code: 21, role: 'Cash Statement (All Cashiers)', link: "cash_statement_cashiers", name: "Cash Statement (All Cashiers)" },
        ]
    },

    {
        code: '4', name: 'Settings', icon: 'settings', link: "setup",
        submenu: [
            { code: 1, role: 'Stock Information Update', link: "stock_info", name: "Stock Information Update" },
            { code: 2, role: 'General Settings', link: "setup", name: "General Settings" },
            { code: 3, role: 'User Management', link: "users", name: "User Management" },
            { code: 7, role: 'Ledger Setup', link: "ledgers", name: "Ledger Setup" },
            { code: 8, role: 'Employees', link: "employee", name: "Employees" },
            { code: 4, role: 'Stock Taking', link: "stock_taking", name: "Stock Taking" },
            { code: 5, role: 'Data Upload', link: "data_upload", name: "Data Upload" },
            { code: 6, role: 'Backup / Restore DB', link: "backup_restore", name: "Backup / Restore DB" }
        ]
    },
];

const InnerModal = ({ children, ...props }) => {
    const dialog = useDialog();

    return <div>
        <ModalContent> {children} </ModalContent>
        <ModalFooter>
            {props.btns.map((b, idx) =>
                <ModalButton key={`modalBtn_${idx}`} className={`pt-1 pb-1 pr-3 pl-3 bg-${b.color}`} onClick={() => { dialog.close(idx); }} >{b.label}</ModalButton>
            )}
        </ModalFooter>
    </div>
};

const GetInitials = (name) => {
    let initials = name.trim().split(' '),
        lname = initials.shift();


    return lname + '_' + (initials.map((n) => n[0]).join('')).toUpperCase();
}

const multiGroupBy = (seq, keys) => {
    if (!keys.length) return seq;
    var first = keys[0];
    var rest = keys.slice(1);
    return _.mapValues(_.groupBy(seq, first), function (value) {
        return multiGroupBy(value, rest);
    });
};

const groupMenu = (menuCode) => {

    let menuKeys = menuCode.split('-'),
        mainMenu = Menu.filter(mn => mn.code == menuKeys[0]),
        fitem = [];

    if (mainMenu.length > 0) {
        let mMenu = mainMenu[0],
            subMenu = mMenu.submenu.filter(mn => mn.code == menuKeys[1]);

        if (subMenu.length > 0) {
            let sMenu = subMenu[0];

            if (sMenu.extra !== undefined) {

                fitem = sMenu.extra;
            }
        }
    }

    return fitem;
}

const delay = ms => new Promise(res => setTimeout(res, ms));

const parseCoilString = (input) => {
    function parseOne(str) {
        const entries = str.split(',').map(item => item.trim().split(':').map(i => i.trim()));
        const obj = {};
        entries.forEach(([key, value]) => {
            const num = Number(value);
            obj[key] = isNaN(num) ? value : num;
        });
        return obj;
    }

    if (Array.isArray(input)) {
        return input.map(parseOne);
    } else if (typeof input === "string") {
        return parseOne(input);
    } else {
        throw new Error("Input must be a string or array of strings.");
    }
}

const formatCoilDescription = (obj) => {
    const {
        Supplier, Guage, Dimension, Material, Texture, Quantity
    } = obj;
    // Assemble pieces
    let desc = `Supplier:${Supplier},Guage:${Guage},Dimension:${Dimension},Material:${Material},Texture:${Texture}`;
    if (Quantity !== undefined) desc += `,Quantity:${Quantity}`;
    return desc;
}

const MojaveLib = () => {

}

MojaveLib.DoLogin = DoLogin;
MojaveLib.Logout = Logout;
MojaveLib.EncryptData = EncryptData;
MojaveLib.DecryptData = DecryptData;
MojaveLib.PrivateKey = PrivateKey;
MojaveLib.SetUser = SetUser;
MojaveLib.GetUser = GetUser;
MojaveLib.SetToken = SetToken;
MojaveLib.SetToken = GetToken;
MojaveLib.SetFeatures = SetFeatures;
MojaveLib.GetFeatures = GetFeatures;
MojaveLib.IsAuthenticated = IsAuthenticated;
MojaveLib.GetAuthorization = GetAuthorization;
MojaveLib.SetCookie = SetCookie;
MojaveLib.GetCookie = GetCookie;
MojaveLib.GetJCookie = GetJCookie;

MojaveLib.DConnect = DConnect;
MojaveLib.PostOptions = PostOptions;
MojaveLib.BaseURL = BaseURL;

MojaveLib.Loader = Loader;
MojaveLib.GetCurl = GetCurl;
MojaveLib.showAlert = showAlert;
MojaveLib.showConfirm = showConfirm;
MojaveLib.HandleError = HandleError;
MojaveLib.MakeId = MakeId;
MojaveLib.Menu = Menu;
MojaveLib.PostImageOptions = PostImageOptions;

MojaveLib.InnerModal = InnerModal;
MojaveLib.NumFormat = NumFormat;
MojaveLib.CurFormat = CurFormat;
MojaveLib.LengthFormat = LengthFormat;
MojaveLib.GetInitials = GetInitials;
MojaveLib.DateFormat = DateFormat;
MojaveLib.MonthRange = MonthRange;

MojaveLib.pageOption = pageOption;
MojaveLib.pageOptions = pageOptions;
MojaveLib.RalConvert = RalConvert;
MojaveLib.unitConvert = unitConvert;
MojaveLib.calcAccessory = calcAccessory;

MojaveLib.Table = Table;
MojaveLib.DateRange = DateRange;
MojaveLib.Local = Local;
MojaveLib.NumtoWords = NumtoWords;
MojaveLib.nl2br = nl2br;
MojaveLib.custIdFormat = custIdFormat;
MojaveLib.prefix = prefix;
MojaveLib.multiGroupBy = multiGroupBy;
MojaveLib.delay = delay;
MojaveLib.groupMenu = groupMenu;

MojaveLib.parseCoilString = parseCoilString;
MojaveLib.formatCoilDescription = formatCoilDescription;

export default MojaveLib;
export {
    MojaveLib, DoLogin, Logout, EncryptData, DecryptData, PrivateKey, SetUser, GetUser, showAlert,
    SetToken, GetToken, SetFeatures, GetFeatures, IsAuthenticated, GetAuthorization, SetCookie,
    GetCookie, DConnect, PostOptions, BaseURL, Loader, GetCurl, HandleError, GetInitials, pageOption,
    MakeId, Menu, PostImageOptions, InnerModal, GetJCookie, showConfirm, NumFormat, CurFormat, DateFormat,
    RalConvert, unitConvert, calcAccessory, LengthFormat, Table, DateRange, Local, NumtoWords, nl2br,
    MonthRange, custIdFormat, prefix, multiGroupBy, delay, pageOptions, groupMenu, parseCoilString,
    formatCoilDescription
}